import { useAuth } from './auth/useAuth';
import { SignIn } from './components/SignIn';
import { AccessDenied } from './components/AccessDenied';
import { AuthedApp } from './components/AuthedApp';
import { ErrorBoundary } from './components/ErrorBoundary';

function AuthLoading(): JSX.Element {
  return (
    <div className="loading-screen">
      <div className="auth-spinner" aria-hidden="true" />
      <div className="muted">Checking sign-in…</div>
    </div>
  );
}

export default function App() {
  const { state, signIn, signOutUser } = useAuth();

  if (state.status === 'loading') {
    return <AuthLoading />;
  }

  if (state.status === 'signed-out') {
    return <SignIn onSignIn={signIn} />;
  }

  if (state.status === 'access-denied') {
    return <AccessDenied email={state.email} onSignOut={signOutUser} />;
  }

  return (
    <ErrorBoundary>
      <AuthedApp
        userEmail={state.user.email || '(no email)'}
        signOut={signOutUser}
      />
    </ErrorBoundary>
  );
}
